import { useEffect, useState } from "react";
import { Label, Modal } from "flowbite-react";
import { useFormik } from "formik";
import { shareExpOfRes } from "../../../services/callAPI/trocsPropositions";
import ValidToast from "../../toasts/ValidToast";
import UnvalidToast from "../../toasts/UnvalidToast";
import { object, string } from "yup";
import { isSanitizeContentShareExpValue } from "../../../services/hooks/sanitizeValue/isSanitizeValue";
import { cleanInputValue } from "../../../services/hooks/sanitizeValue/cleanInputValue";

interface IShareExpModalProps {
  travTrocId: number;
  resTrocId: number,
  setTrigUseEffect: React.Dispatch<React.SetStateAction<boolean>>;
}

function ShareExpRes(props: IShareExpModalProps) {
  //destructuring
  const { resTrocId, travTrocId, setTrigUseEffect } = props;

  const [openModal, setOpenModal] = useState(false);

  const [_comment, _setComment] = useState<string>("");

  const [isShowValidToast, setIsShowValidToast] = useState<boolean>(false);

  const [isShowUnvalidToast, setIsShowUnvalidToast] = useState<boolean>(false);

  //set validation schema with Yup
  const shareExpSchema = object({
    content: string()
      .trim()
      .min(20, "Le commentaire doit comporter au moins 20 caractères")
      .max(160, "Le commentaire ne peut pas dépasser 160 caractères")
      .test("is-pseudo-valid", "pseudo contient des caractères non-imprimables ou interdits", (value) => isSanitizeContentShareExpValue(value))
      .matches(/^[a-zA-ZÀ-ÿ_.,'!?; ]+$/, "Peut contenir des lettres, et certains caractères spéciaux(_.,'!?;)")
      .required(`Vous avez oublié votre commentaire`),
  })

  // set formik
  const { handleSubmit, setFieldValue, errors, touched, values, resetForm } = useFormik({
    initialValues: {
      content: "",
    },
    validationSchema: shareExpSchema,
    onSubmit: async values => {
      try {
        //call Api
        const status = await shareExpOfRes(values, resTrocId, travTrocId);

        if (status === 204) { //success
          //show ValidToast
          setIsShowValidToast(true);
        }
        else {//failure
          throw new Error(`Erreur lors de la création du commentaire.`);
        }
      } catch (error) {
        //show UnvalidToast
        setIsShowUnvalidToast(true);
      } finally {
        //reset form
        resetForm();

        //close modal
        setOpenModal(false);
      }
    }
  })

  useEffect(() => {
    let timer: NodeJS.Timeout | null = null;

    if (isShowValidToast) {
      timer = setTimeout(() => {
        setTrigUseEffect(prev => !prev);
      }, 3000);
    }

    return () => {
      if (timer) clearTimeout(timer);
    };
  }, [isShowValidToast]);

  return (
    <>
      {isShowValidToast && <ValidToast onClose={() => setIsShowValidToast(false)} />}
      {isShowUnvalidToast && <UnvalidToast onClose={() => setIsShowUnvalidToast(false)} />}

      <button className="w-1/2 px-1 max-w-52 bg-greenCustom text-white rounded-md py-1 ml-auto" onClick={() => setOpenModal(true)}>Laisser un commentaire</button>

      <Modal className="p-6 bg-transparent backdrop-blur-sm" show={openModal} size="md" popup onClose={() => setOpenModal(false)}>
        <Modal.Body>
          <form action="" onSubmit={handleSubmit} >

            <div className="space-y-6">

              <h3 className="text-xl font-medium text-center text-gray-900 dark:text-white">Je partage cette expérience :</h3>

              <div>

                <div className="mb-2 block">
                  <Label htmlFor="content" value="" />
                </div>

                {/* Mon commentaire */}
                <textarea
                  id="content"
                  name="content"
                  value={values.content}
                  onChange={(e) => {
                    const cleaned = cleanInputValue(e.target.value);
                    setFieldValue("content", cleaned);
                  }}
                  placeholder="Laisser un commentaire ..."
                  className="border rounded w-full"
                  rows={4}
                />

                <p className="text-end text-gray-400">160 caractères max</p>

                {touched.content && errors.content && <span className="text-red-500 text-sm">{errors.content}</span>}

              </div>

              <div className="flex justify-around w-full">
                <button type="submit" className="bg-greenCustom py-1 px-3 rounded-xl w-1/3 text-white flex justify-center">Envoyer</button>
                <button className="bg-lightRedCustom py-1 px-3 rounded-xl w-1/3 text-white flex justify-center" onClick={() => { resetForm(), setOpenModal(false) }}>Retour</button>
              </div>

            </div>

          </form>
        </Modal.Body>
      </Modal>
    </>
  );
}

export default ShareExpRes;
